import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { Route } from 'vue-router';
import { getFromSessionStorage } from '@/apps/order/helper';
import { FormDataProxy } from '@/utils/FormHelpers';
import { useOrdersCreateCalculatorStore } from '@/apps/order/stores/ordersCreate';

import TariffInterface from '@/apps/order/interfaces/TariffInterface';

let alreadyFetched = false;

const hasCalculatorFormData = async (to: Route): Promise<void> => new Promise<void>((resolve, reject) => {
  const ctx = to.meta?.ctx;
  nextTick(async () => {
    try {
      const calculatorStore = useOrdersCreateCalculatorStore();
      const {
        formData, selectedTariffs, transitionTariffs, streets,
      } = storeToRefs(calculatorStore);

      let calculatorFormData;
      let calculatorSelectedTariffs;
      let calculatorTransitionTariffs;
      let calculatorStreets;

      if (!alreadyFetched) {
        calculatorFormData = getFromSessionStorage<Record<string, any>>(`${ctx}.calculatorFormData`);
        calculatorSelectedTariffs = getFromSessionStorage<Record<string, any>>(`${ctx}.calculatorSelectedTariffs`);
        calculatorTransitionTariffs = getFromSessionStorage<TariffInterface[]>(`${ctx}.calculatorTransitionTariffs`);
        calculatorStreets = getFromSessionStorage<Record<string, any>[]>(`${ctx}.calculatorStreets`);
        alreadyFetched = true;
      }

      if (calculatorFormData !== undefined) {
        formData.value = new FormDataProxy(calculatorFormData);
      }

      if (calculatorSelectedTariffs !== undefined) {
        selectedTariffs.value = calculatorSelectedTariffs;
      }

      if (calculatorTransitionTariffs !== undefined) {
        transitionTariffs.value = calculatorTransitionTariffs;
      }

      if (calculatorStreets !== undefined) {
        streets.value = calculatorStreets;
      }

      resolve();
    } catch (e) {
      reject(new Error(['fetch data prepared failed', e].join(' ')));
    }
  });
});

export default hasCalculatorFormData;
